// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"da8fefc6","787":"382911c8","849":"dcb2ef54"}[chunkId] + ".chunk.js";
};